module.exports = __webpack_public_path__ + "img/empty-barista-red.b20559c.svg";